import { Component, OnInit } from '@angular/core';
import { AppUtils } from 'src/app/helpers/app.utils';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageUrls } from 'src/app/helpers/page-urls';
import { TableModel } from 'src/app/models/table.model';
import { Subscription } from 'rxjs';
import { GettyOrderService } from 'src/app/admin/services/getty.order.service';
import { PagedGettyOrderDetail } from 'src/app/admin/models/paged.getty.order.detail';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GettyOrderZohoSyncComponent } from '../zoho-sync-dialog/getty.order.zoho.sync.dialog.component';

@Component({
    selector: 'app-getty-order-list',
    templateUrl: './getty.order.list.component.html',
    styleUrls: ['./getty.order.list.component.scss']
})
export class GettyOrderListComponent implements OnInit {

    totalRecords = 0;
    pagedGettyOrderDetails = new PagedGettyOrderDetail();
    subscriptions = new Array<Subscription>();
    tableModel = new TableModel();
    isModelLoaded = false;

    get urls() {
        return PageUrls;
    }

    constructor(private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private gettyOrderService: GettyOrderService,
        private modalService: NgbModal) {
        this.tableModel.orderBy = 'CreatedOn';
        this.tableModel.orderByDirection = 'desc';
    }

    ngOnInit() {
        this.initSubscribers();
        this.getGettyOrders();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getGettyOrders());
        this.subscriptions.push(subscription);
    }

    getGettyOrders() {
        this.spinner.show();
        this.gettyOrderService.list(this.tableModel).subscribe(
            data => {
                Object.assign(this.pagedGettyOrderDetails, data);
                this.totalRecords = data.totalCount;
                this.pagedGettyOrderDetails.items.forEach(order => {
                    order.createdOn = AppUtils.getFormattedDate(order.createdOn);
                });

                this.spinner.hide();
                this.isModelLoaded = true;
            },
            error => {
                this.spinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    openZohoSyncDialog(): void {
        const modal = this.modalService.open(GettyOrderZohoSyncComponent);
        modal.result.then(() => {
            this.getGettyOrders();
        });
    }
}
